// extracted by mini-css-extract-plugin
export default {"title":"CTABannerSingle_title__r-AXi","alignedCenter":"CTABannerSingle_alignedCenter__s4MMl"};